const namespaced = true

const state = {
  list: [],
  page: 2,
  section: '',
  list_loading: false,
  left_product: 12,
}

const getters = {
  list: state => state.list,
  list_loading: state => state.list_loading,
  left_product: state => state.left_product,
}

const mutations = {
  paginate: (state, payload) => {
    state.page += 1
    state.list = payload.length ? [...state.list, ...payload] : state.list
  },
  list_loading: state => {
    state.list_loading = true
  },
  list_loaded: state => {
    state.list_loading = false
  },
  set_section: (state, payload) => {
    state.section = payload
  },
  set_left_product: (state, payload) => {
    state.left_product = payload
  },
}

const actions = {
  paginate: ({ commit, state }) => {
    commit('list_loading')
    axios.get(`/api/section/${state.section}?page=${state.page}`).then(({ data }) => {
      commit('paginate', data.data)
      const left_product = data.meta.total - data.meta.to
      commit(
        'set_left_product',
        left_product <= 12 ? left_product : 12,
      )
      return data
    }).finally(() => commit('list_loaded'))
  },
}

export default {
  mutations,
  actions,
  state,
  getters,
  namespaced,
}
